import React from 'react'
import { BrowserRouter as Router, Navigate, Routes, Route } from "react-router-dom"
import Home from "./pages/home"
import LoginPage from "./pages/login"
import Dashboard from "./pages/dashboard"
import Locations from "./pages/locations"
import PrivateRoutes from "./guards/PrivateRoutes"
import ResetPasswordPage from "./pages/resetPassword"
import MainLayout from "./layouts/mainLayout"
// import AddOwner from "./pages/addOwner"
import AddLocation from "./pages/addLocation"
import LoadingSpinTrail from "./components/loading/LoadingSpinTrail"
import UserProfile from "./pages/userProfile"
import SingleLocation from "./pages/locations/location"
import AddOrganization from "./pages/addOrganization"
import SingleOrganization from "./pages/organizations/organization"
import UpdateProfile from "./pages/userProfile/updateProfile"
import UpdateOrganization from "./pages/organizations/organization/updateOrganization"
import Organizations from "./pages/organizations"
import Users from "./pages/users"
import CreatWalks from "./pages/locations/location/createWalks"
import SingleWalkReport from "./pages/locations/location/walkReport"
import TermsOfServicePage from "./pages/legal/termsOfService"
import PrivacyPolicyPage from "./pages/legal/privacyPolicy"
import ResetEmailSentPage from "./pages/resetPassword/emailSent"
import ConfirmNewPasswordPage from "./pages/resetPassword/confirmNewPassword"
import UpdateLocation from "./pages/locations/location/updateLocation"
import AddUser from "./pages/addUser"
import ManagementCompaniesPage, { ManagementCompanyFormRoute } from "./pages/managementCompanies"
import IncidentDetail from "./components/incidents/IncidentDetail"
import DeleteAccountPage from "./pages/deleteAccount"
import DeleteAccountEmailSentPage from "./pages/deleteAccount/emailSent"
import ConfirmDeleteAccountPage from "./pages/deleteAccount/confirm"
import StorageLocationRoutes from "./guards/StorageLocationRoutes"
import DailyHoursPreview from "./pages/jobSites/jobSite/DailyHoursPreview"
import CompaniesPreview from "./pages/companies/CompaniesPreview"
import EmployeesPreview from "./pages/employees/EmployeesPreview"
import JobSitesPreview from "./pages/jobSites/JobSitesPreview"
import DashboardPreview from "./pages/dashboard/DashboardPreview"
import JobSiteCodesPreview from "./pages/jobSites/jobSite/JobSiteCodesPreview"
import EmployeesPage from "./pages/employees"
import AdminModePage from "./pages/adminMode"
import AdminModePreview from "./pages/adminMode/AdminModePreview"
import TimeClockPage from "./pages/timeClock"
import TimeClockPreview from "./pages/timeClock/TimeClockPreview"
import ConstructionAdminRoute from "./guards/ConstructionAdminRoute"
import CompanyScopedRoute from "./guards/CompanyScopedRoute"

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<PrivateRoutes />}>
          <Route path="/app" element={<MainLayout />}>
            <Route path="/app" element={<Dashboard />} />
            <Route path="/app/users" element={<Users />} />
            <Route path="/app/users/:id" element={<UserProfile />} />
            <Route path="/app/users/update/:id" element={<UpdateProfile />} />
            <Route path="/app/locations" element={<CompanyScopedRoute><Locations /></CompanyScopedRoute>} />
            <Route path="/app/locations/:id/create-walks" element={<StorageLocationRoutes><CreatWalks /></StorageLocationRoutes>} />
            <Route path="/app/locations/:id/walk-report/:walkReportId" element={<StorageLocationRoutes><SingleWalkReport /></StorageLocationRoutes>} />
            <Route path="/app/locations/:id" element={<CompanyScopedRoute><SingleLocation /></CompanyScopedRoute>} />
            <Route path="/app/locations/update/:id" element={<StorageLocationRoutes><UpdateLocation /></StorageLocationRoutes>} />
            <Route path="/app/addLocation" element={<StorageLocationRoutes><AddLocation /></StorageLocationRoutes>} />
            <Route path="/app/job-codes" element={<Navigate to="/app/locations" replace />} />
            <Route path="/app/employees" element={<CompanyScopedRoute><EmployeesPage /></CompanyScopedRoute>} />
            <Route path="/app/admin-mode" element={<CompanyScopedRoute><AdminModePage /></CompanyScopedRoute>} />
            <Route path="/app/time-clock" element={<CompanyScopedRoute><TimeClockPage /></CompanyScopedRoute>} />
            <Route path="/app/organizations" element={<Organizations />} />
            <Route path="/app/organizations/:id" element={<SingleOrganization />} />
            <Route path="/app/organizations/update/:id" element={<UpdateOrganization />} />
            <Route path="/app/addOrganization" element={<AddOrganization />} />
            <Route path="/app/addUser" element={<AddUser />} />
            <Route path="/app/management-companies" element={<ConstructionAdminRoute><ManagementCompaniesPage /></ConstructionAdminRoute>} />
            <Route path="/app/management-companies/add" element={<ManagementCompanyFormRoute />} />
            <Route path="/app/management-companies/:id" element={<ManagementCompanyFormRoute />} />
            <Route path="/app/incidents/:id" element={<IncidentDetail />} />
            <Route path="/app/loading" element={<LoadingSpinTrail />} />
          </Route>
        </Route>
        <Route path="terms-of-service" element={<TermsOfServicePage />} />
        <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="reset-password" element={<ResetPasswordPage />} />
        <Route path="reset-password/email-sent" element={<ResetEmailSentPage />} />
        <Route path="reset-password/confirm" element={<ConfirmNewPasswordPage />} />
        <Route path="/" element={<Home />} />
          <Route path="/preview/job-site-daily-hours" element={<DailyHoursPreview />} />
          <Route path="/preview/companies" element={<CompaniesPreview />} />
          <Route path="/preview/employees" element={<EmployeesPreview />} />
          <Route path="/preview/job-sites" element={<JobSitesPreview />} />
          <Route path="/preview/dashboard" element={<DashboardPreview />} />
          <Route path="/preview/job-site-codes" element={<JobSiteCodesPreview />} />
          <Route path="/preview/admin-mode" element={<AdminModePreview />} />
          <Route path="/preview/time-clock" element={<TimeClockPreview />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/deleteAccount" element={<DeleteAccountPage />} />
        <Route path="/deleteAccount/email-sent" element={<DeleteAccountEmailSentPage />} />
        <Route path="/deleteAccount/confirm/:token" element={<ConfirmDeleteAccountPage />} />
        {/* <Route path="/signup" element={<SignupPage/>} /> */}
        <Route
          path="error"
          element={
            <span className="flex h-full items-center">
              <h1>An Error has occured</h1>
            </span>
          }
        />
        <Route
          path="*"
          element={
            <span className="flex h-full items-center">
              <h1>404 Page Not Found</h1>
            </span>
          }
        />
      </Routes>
    </Router>
  )
}

export default App
